<script lang="ts">
	interface Props {
		strokeColor?: string;
	}

	let { strokeColor = "black" }: Props = $props();
</script>

<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
	<g clip-path="url(#clip0_28_83)">
		<path
			d="M1.5001 51.5884C1.5001 51.5884 14 40.5005 15.5 40.5004C17 40.5002 26 51.5884 28 51.5884C30 51.5884 44 28.5 46.5 28.5C49 28.5 62.5001 51.5884 62.5001 51.5884"
			stroke={strokeColor}
			class="svg-stroke"
			stroke-width="4"
		/>
		<rect
			x="2"
			y="2"
			width="60"
			height="60"
			rx="6"
			stroke={strokeColor}
			class="svg-stroke"
			stroke-width="4"
		/>
		<circle cx="18" cy="18" r="7" stroke={strokeColor} class="svg-stroke" stroke-width="4" />
	</g>
	<defs>
		<clipPath id="clip0_28_83">
			<rect width="64" height="64" fill="white" />
		</clipPath>
	</defs>
</svg>
